import about5title1 from "../../assets/images/about5title1.png";
import about5title2 from "../../assets/images/about5title2.png";
import about5bg1 from "../../assets/images/about5bg1.png";
import fuli1 from "../../assets/images/fuli/1.png";
import fuli2 from "../../assets/images/fuli/2.png";
import fuli3 from "../../assets/images/fuli/3.png";
import fuli4 from "../../assets/images/fuli/4.png";
import { useState, useEffect } from "react";
import style from "./About5.module.css";
import request from "../../common/request";
export default function Main() {
  const [currentActive, setCurrentActive] = useState([false, false]);
  const [list, setList] = useState([]);
  useEffect(() => {
    request.getColumnList("招聘计划").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        data.forEach((element) => {
          element.isActive = false;
        });
        setList(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.about5box}>
        <div className={"div30"}></div>
        <img src={about5title1} />
        <div className={"div30"}></div>
        <div className={style.fulibox}>
          <div>
            <img src={fuli1} />
          </div>
          <div>
            <h3>福利</h3>
            <p>节日福利 生日福利</p>
          </div>
          <div>
            <img src={fuli2} />
          </div>
          <div>
            <h3>补贴</h3>
            <p>每月餐补 全勤奖</p>
            <p>公司年度旅游</p>
          </div>
          <div className={style.marginleft0}>
            <h3>休息时间</h3>
            <p>法定节假日休息</p>
            <p>周末双休 带薪年假</p>
          </div>
          <div>
            <img src={fuli3} />
          </div>
          <div>
            <h3>社保</h3>
            <p>交通补贴 五险一金</p>
            <p>年终奖金</p>
          </div>
          <div>
            <img src={fuli4} />
          </div>
        </div>
        <div className={"div100"}></div>
        <img src={about5title2} />
        <div className={"div30"}></div>
        <div className={style.recruitmentbox}>
          <p>
            {" "}
            <span className={style.span1}>招聘岗位{currentActive[0]}</span>{" "}
            <span className={style.span2}>招聘人数</span>{" "}
            <span
              className={style.span3}
              style={{ position: "relative", left: "-120px" }}
            >
              薪资待遇
            </span>{" "}
          </p>

          {list.map((item, index) => {
            return (
              <div className={style.listRow} key={index}>
                <p>
                  <span className={style.span1} style={{ fontWeight: "bold" }}>
                    {item.title}
                  </span>
                  <span className={style.span2 + " " + style.span2e}>
                    {item.width}人
                  </span>
                  <span className={style.span3}>
                    {item.desc}
                    <button
                      onClick={() => {
                        var tmp = [...list];

                        tmp[index].isActive = !tmp[index].isActive;

                        setList(tmp);
                        console.log(list);
                      }}
                    >
                      {" "}
                      查看内容
                    </button>
                  </span>
                </p>
                {list[index].isActive == true && (
                  <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
